import { post } from './http';

/**
 * Make a Coral RPC call using X-Amz-Target header
 */
export async function coralRpc<TResponse>(
  operation: string,
  request: unknown,
  signal?: AbortSignal
): Promise<TResponse> {
  return post<TResponse>('/', request, {
    signal,
    headers: {
      'Content-Encoding': 'amz-1.0', // coral specific
      'X-Amz-Target': `IRISCatalogMetadataService.${operation}`,
    },
  });
}
